module.exports = __webpack_public_path__ + "img/ico036.7036def6.svg";